"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var Icon_1 = __importDefault(require("../Icon"));

var Separator_1 = __importDefault(require("../Separator"));

var commonStyle = function commonStyle(theme) {
  return "\n  padding: 0;\n  margin: 0;\n  color: " + theme.textColor + ";\n  font-weight: 500;\n";
}; // H1


var StyledH1 = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return commonStyle(theme);
}, polished_1.rem(32)); // H2

var StyledH2 = styled_components_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return commonStyle(theme);
}, polished_1.rem(28)); // H3

var StyledH3 = styled_components_1.default.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return commonStyle(theme);
}, polished_1.rem(24)); // H4

var StyledH4 = styled_components_1.default.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return commonStyle(theme);
}, polished_1.rem(20)); // H5

var StyledH5 = styled_components_1.default.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  font-size: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return commonStyle(theme);
}, polished_1.rem(16));
var Wrapper = styled_components_1.default('div')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  width: 100%;\n"], ["\n  ", "\n  display: flex;\n  width: 100%;\n"])), function (_a) {
  var withSeparator = _a.withSeparator,
      noBottomGutter = _a.noBottomGutter;

  if (!withSeparator && !noBottomGutter) {
    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        margin-bottom: ", ";\n      "], ["\n        margin-bottom: ", ";\n      "])), polished_1.rem(15));
  }

  return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
});
var InnerWrapper = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var InnerWrapperContext = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var InnerWrapperIcon = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var InnerWrapperHeader = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var StyledIcon = styled_components_1.default(Icon_1.default)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  padding-right: 0.7rem;\n  padding-left: 0.5rem;\n"], ["\n  padding-right: 0.7rem;\n  padding-left: 0.5rem;\n"])));
var Subtitle = styled_components_1.default('div')(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var size = _a.size;

  switch (size) {
    case 'xs':
      {
        return styled_components_1.css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(12));
      }

    case 's':
      {
        return styled_components_1.css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(13));
      }

    case 'm':
      {
        return styled_components_1.css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(14));
      }

    case 'l':
      {
        return styled_components_1.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(16));
      }

    case 'xl':
      {
        return styled_components_1.css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(20));
      }

    default:
      {
        return styled_components_1.css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(26));
      }
  }
});
var StyledSeparator = styled_components_1.default(Separator_1.default)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  margin-top: ", ";\n"], ["\n  margin-bottom: ", ";\n  margin-top: ", ";\n"])), polished_1.em(4), polished_1.em(4));
var SeparatorSizer = styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  padding: ", " 0;\n  display: flex;\n  ", "\n"], ["\n  padding: ", " 0;\n  display: flex;\n  ", "\n"])), polished_1.rem(5), function (_a) {
  var size = _a.size;

  switch (size) {
    case 'xs':
      {
        return styled_components_1.css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(16));
      }

    case 's':
      {
        return styled_components_1.css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(20));
      }

    case 'l':
      {
        return styled_components_1.css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(24));
      }

    case 'xl':
      {
        return styled_components_1.css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(28));
      }

    default:
      {
        return styled_components_1.css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n          font-size: ", ";\n        "], ["\n          font-size: ", ";\n        "])), polished_1.rem(32));
      }
  }
});

var SizedHeader = function SizedHeader(_a) {
  var size = _a.size,
      className = _a.className,
      children = _a.children;

  switch (size) {
    case 'xs':
      {
        return React.createElement(StyledH5, {
          className: className
        }, children);
      }

    case 's':
      {
        return React.createElement(StyledH4, {
          className: className
        }, children);
      }

    case 'l':
      {
        return React.createElement(StyledH2, {
          className: className
        }, children);
      }

    case 'xl':
      {
        return React.createElement(StyledH1, {
          className: className
        }, children);
      }

    default:
      {
        return React.createElement(StyledH3, {
          className: className
        }, children);
      }
  }
};

var defaultProps = {
  size: 'm',
  className: '',
  children: '',
  iconSize: 'xl',
  withSeparator: false,
  noBottomGutter: false
};

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Header.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        className = _a.className,
        children = _a.children,
        icon = _a.icon,
        subtitle = _a.subtitle,
        iconSize = _a.iconSize,
        withSeparator = _a.withSeparator,
        noBottomGutter = _a.noBottomGutter,
        restProps = __rest(_a, ["size", "className", "children", "icon", "subtitle", "iconSize", "withSeparator", "noBottomGutter"]);

    return React.createElement(Wrapper, __assign({
      withSeparator: withSeparator,
      noBottomGutter: noBottomGutter
    }, restProps), React.createElement(InnerWrapper, null, React.createElement(InnerWrapperContext, null, React.createElement(InnerWrapperIcon, null, icon && React.createElement(StyledIcon, {
      size: size,
      name: icon
    })), React.createElement(InnerWrapperHeader, null, React.createElement(SizedHeader, {
      size: size,
      className: className
    }, children), subtitle && React.createElement(Subtitle, {
      size: size
    }, subtitle))), withSeparator && React.createElement(SeparatorSizer, {
      size: size
    }, React.createElement(StyledSeparator, null))));
  };

  Header.defaultProps = defaultProps;
  return Header;
}(React.PureComponent);

exports.default = Header;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27;